// mds-dojo — dijit/_Container — FAITHFUL port of references/dijit/_Container.js.
// Codemod pipeline (define→ESM+declare); declare from the faithful runtime; unused
// `kernel` import dropped. Staged (.faithful) pending the atomic base-chain swap.
// Mixin for widgets that contain HTML and/or a set of widget children.
import array from '../dojo/_base/array';
import declare from '../dojo/_base/declare-runtime';
import domConstruct from '../dojo/dom-construct';

export default declare('dijit._Container', null, {
  buildRendering: function () {
    this.inherited(arguments);
    if (!this.containerNode) {
      // All widgets with descendants must set containerNode.
      this.containerNode = this.domNode;
    }
  },

  addChild: function (widget: any, insertIndex: any) {
    // Make the given widget a child: insert its domNode into containerNode.
    var refNode = this.containerNode;
    if (insertIndex > 0) {
      // nth element child (skipping text/comment nodes)
      refNode = refNode.firstChild;
      while (insertIndex > 0) {
        if (refNode.nodeType == 1) { insertIndex--; }
        refNode = refNode.nextSibling;
      }
      if (refNode) {
        insertIndex = 'before';
      } else {
        refNode = this.containerNode;
        insertIndex = 'last';
      }
    }

    domConstruct.place(widget.domNode, refNode, insertIndex);

    // Start the child if I've been started but it hasn't.
    if (this._started && !widget._started) {
      widget.startup();
    }
  },

  removeChild: function (widget: any) {
    // Remove the widget (or index) from this container without destroying it.
    if (typeof widget == 'number') {
      widget = this.getChildren()[widget];
    }
    if (widget) {
      var node = widget.domNode;
      if (node && node.parentNode) {
        node.parentNode.removeChild(node); // detach but don't destroy
      }
    }
  },

  hasChildren: function () {
    return this.getChildren().length > 0;
  },

  _getSiblingOfChild: function (child: any, dir: number) {
    // Get the next (dir=1) or previous (dir=-1) widget sibling of child.
    var children = this.getChildren(),
      idx = array.indexOf(children, child);
    return children[idx + dir];
  },

  getIndexOfChild: function (child: any) {
    // Index of the child in this container, or -1.
    return array.indexOf(this.getChildren(), child);
  },
});
